import { StoreGetProductsParams } from "@medusajs/medusa"
import Head from "@modules/common/components/head"
import Layout from "@modules/layout/templates"
import InfiniteProducts from "@modules/products/components/infinite-products"
import RefinementList from "@modules/store/components/refinement-list"
import { useState } from "react"
import { FormattedMessage } from "react-intl"
import { NextPageWithLayout } from "types/global"
import clsx from "clsx"

const AkoestischePanelen: NextPageWithLayout = () => {
    const [params, setParams] = useState<StoreGetProductsParams>({})

    return (
        <>
            <Head
                title="Producten"
                description="Explore all of our products."
            />
            <div className={"grain-background"}>
                <div
                    className={
                        "relative z-10 grid grid-cols-6 px-4 py-7 lg:px-12 lg:py-20"
                    }
                >
                    <div className={clsx("col-span-2 ml-16")}>
                        <h1
                            className={
                                "text-lg md:text-xl lg:text-3xl 2xl:text-5xl font-display font-base subpixel-antialiased mb-6"
                            }
                        >
                            <FormattedMessage
                                id={"producten-title"}
                                defaultMessage={"Producten"}
                            />
                        </h1>
                    </div>

                    <div className="col-span-4 ml-16 text-darkTone">
                        <p
                            className={
                                "text-base mb-6 px-8 mx-auto font-mono subpixel-antialiased"
                            }
                        ></p>
                    </div>
                    <div className="relative block col-span-1">
                        <RefinementList
                            refinementList={params}
                            setRefinementList={setParams}
                        />
                    </div>
                    <div className="col-span-5 px-8 transition flex flex-col small:items-start py-6">
                        <div className={"content-container "}>
                            <InfiniteProducts params={params} />
                        </div>
                    </div>
                </div>
                <div
                    className={"absolute inset-0 z-0 pointer-events-none"}
                    style={{
                        background:
                            "linear-gradient(\n" +
                            "    to right,\n" +
                            "    transparent 0%,\n" +
                            "    transparent 33.33%,\n" +
                            "    #f6f6f6 33.33%,\n" +
                            "    #f6f6f6 100%\n" +
                            "  )",
                    }}
                >
                    &nbsp;
                </div>
            </div>
        </>
    )
}

AkoestischePanelen.getLayout = (page) => <Layout>{page}</Layout>

export default AkoestischePanelen
